import type { DOMPurify } from 'dompurify';

export function sanitize(DOMPurify: DOMPurify, html: string): string {
  return DOMPurify.sanitize(html, {
    ALLOWED_TAGS: ['p', 'em', 'strong', 'u', 'a'],
    ALLOWED_ATTR: ['href', 'rel', 'target'],
  });
}

interface IDOMParser {
  parseFromString(html: string, type: 'text/html'): { body: { innerText: string } };
}

export function stripTags(parser: IDOMParser, html: string): string {
  return parser.parseFromString(html.replace(/<\/p><p/g, '</p> <p'), 'text/html').body.innerText ?? '';
}
